/**
 * @generated SignedSource<<70f80cc70701b6adcb72c2ecdca9df0e>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type PrefillIdentityDetailsResponseError = 'INVALID_AUTH' | 'UNEXPECTED_ERROR' | '%future added value';
export type PersonalInformationPagePrefillQuery$variables = Record<PropertyKey, never>;
export type PersonalInformationPagePrefillQuery$data = {
  readonly prefillIdentityDetails: {
    readonly data: {
      readonly dateOfBirth: string;
      readonly e164: string;
      readonly email: string;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
      readonly ssnLast4: string;
    } | null;
    readonly errors: ReadonlyArray<PrefillIdentityDetailsResponseError>;
  };
};
export type PersonalInformationPagePrefillQuery = {
  response: PersonalInformationPagePrefillQuery$data;
  variables: PersonalInformationPagePrefillQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
    {
      alias: null,
      args: [
        {
          kind: 'Literal',
          name: 'q',
          value: {},
        },
      ],
      concreteType: 'PrefillIdentityDetailsResponseValidation',
      kind: 'LinkedField',
      name: 'prefillIdentityDetails',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'PrefillIdentityDetailsResponse',
          kind: 'LinkedField',
          name: 'data',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'id',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'firstName',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'lastName',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'email',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'e164',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'dateOfBirth',
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'ssnLast4',
              storageKey: null,
            },
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'errors',
          storageKey: null,
        },
      ],
      storageKey: 'prefillIdentityDetails(q:{})',
    },
  ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'PersonalInformationPagePrefillQuery',
      selections: v0 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'PersonalInformationPagePrefillQuery',
      selections: v0 /*: any*/,
    },
    params: {
      cacheID: '402bf2de9e434a92981ac758b3d05c00',
      id: null,
      metadata: {},
      name: 'PersonalInformationPagePrefillQuery',
      operationKind: 'query',
      text: 'query PersonalInformationPagePrefillQuery {\n  prefillIdentityDetails(q: {}) {\n    data {\n      id\n      firstName\n      lastName\n      email\n      e164\n      dateOfBirth\n      ssnLast4\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'b51b184d25b13b7dcde309a3d387f880';

export default node;
